<script>
import PagenationContainer from "@/components/common/PagenationContainer.vue";

export default {
  components: {
    PagenationContainer
  },
  props: {
    reportList: Array,
    sourceData: Object
  },
  data() {
    const pageCount = this.sourceData ? this.sourceData.totalPages : 0;
    return {
      pageCount,
      activePage: this.sourceData ? this.sourceData.number + 1 : 1
    };
  },
  watch: {
    sourceData: function(newVal) {
      this.pageCount = newVal ? newVal.totalPages : 0;
      this.activePage = newVal ? newVal.number + 1 : 1;
    }
  },
  methods: {
    handleSizeChange(val) {},
    handleCurrentChange(val) {
      if (!val) val = 1;
      this.activePage = val;
      let params = {
        page: this.activePage - 1
      };
      this.$emit("handleCurrentChange", "optoTestingReport", params);
    },
    onDownload(row) {
      this.$emit("download", row);
    }
  }
};
</script>

<template>
  <div class="optoTestingReportIndex">
    <el-table
      :data="reportList"
      class="optoTestingTable"
      :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
      :cell-style="{'padding-left': '5px'}"
    >
      <el-table-column prop="createdAt" align="left" label="日期" min-width="160">
        <template slot-scope="scope">
          {{ scope.row.createdAt ? moment(scope.row.createdAt, "YYYY-MM-DD HH:mm") : "--" }}
        </template>
      </el-table-column>
      <el-table-column prop="doctor" align="left" label="检查医生" min-width="160">
        <template slot-scope="scope">
          {{ scope.row.createdBy.name || "--" }}
        </template>
      </el-table-column>
      <!--<el-table-column prop="testingItems" align="left" label="检查项目" min-width="200">
        <template slot-scope="scope">
          {{ scope.row.testingItems && scope.row.testingItems.length ? scope.row.testingItems.join("、") : "--" }}
        </template>
      </el-table-column>-->
      <el-table-column prop="hospital" align="left" label="检查医院" min-width="180">
        <template slot-scope="scope">
          {{ scope.row.hospital || "--" }}
        </template>
      </el-table-column>
      <el-table-column align="left" label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="onDownload(scope.row)">下载报告</el-button>
        </template>
      </el-table-column>
    </el-table>
    <PagenationContainer v-if="pageCount > 1">
      <el-pagination
        @size-change="handleSizeChange"
        background
        @current-change="handleCurrentChange"
        :current-page="activePage"
        :page-count="pageCount"
        layout="prev, pager, next, jumper"
      ></el-pagination>
    </PagenationContainer>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.optoTestingReportIndex {
  .optoTestingTable {
    margin: 20px 2%;
    border: 1px;
    width: 97%;

    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/patientManagement/optoTestingReport.vue